import { useEffect, useState } from 'react';

export default function HomePage() {
  const [activeAccordion, setActiveAccordion] = useState<number | null>(null);
  const [isHeaderScrolled, setIsHeaderScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsHeaderScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleAccordion = (index: number) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const faqData = [
    {
      question: "Sınavlar hangi dilde yapılır?",
      answer: "Tüm sınavlar Japonca dilinde yapılır. JLPT (Japanese Language Proficiency Test) tamamen Japonca'dır. Sektörel beceri sınavları da Japonca'dır. Bu nedenle en az N4 seviyesinde Japonca bilgisi kritik öneme sahiptir."
    },
    {
      question: "Sınavda başarısız olursam tekrar girebilir miyim?",
      answer: "Evet, sınavlara tekrar girebilirsiniz. JLPT yılda iki kez (Temmuz ve Aralık) düzenlenir. Sektörel beceri sınavları ise sektöre göre farklı tarihlerde yapılır. Başarısız olmanız durumunda bir sonraki sınav döneminde tekrar başvurabilirsiniz."
    },
    {
      question: "N4 JLPT ile SSW Japonca sınavı aynı mı?",
      answer: "Hayır, farklıdır. JLPT N4 genel Japonca yeterlilik sınavıdır. SSW için ise hem genel Japonca hem de sektöre özel Japonca bilgisi değerlendirilir. Ancak N4 seviyesinde Japonca bilgisi, SSW sınavlarına hazırlık için temel oluşturur."
    },
    {
      question: "Başvurudan Japonya'ya gidiş süreci ne kadar sürer?",
      answer: "Nisan dönemi için örnek süreç: Ekim ayında evrak hazırlığı başlar, Aralık-Şubat arası inceleme süreci, Şubat sonu COE (Certificate of Eligibility) onayı, Mart ayında vize başvurusu ve Nisan başında Japonya'ya varış. Toplam süreç yaklaşık 6 aydır. Diğer dönemler için süreler benzerdir."
    },
    {
      question: "İş garantisi var mı?",
      answer: "Hayır, iş garantisi verilmez. Ancak STEB olarak dil eğitimi, sınav hazırlığı ve iş başvuru süreçlerinde kapsamlı destek sağlarız. Japonca seviyeniz ve sektörel becerileriniz arttıkça istihdam şansınız önemli ölçüde yükselir. SSW sınavlarını başarıyla tamamlayanlar için iş bulma oranı oldukça yüksektir."
    },
    {
      question: "Konaklama nasıl sağlanır?",
      answer: "Konaklama seçenekleri duruma göre değişir. Dil okulu döneminde genellikle öğrenci yurtları veya share house seçenekleri sunulur. İş başladıktan sonra bazı işverenler lojman sağlar, bazılarında ise kendi konaklama yerinizi bulmanız gerekir. STEB olarak konaklama konusunda da rehberlik sağlarız."
    },
    {
      question: "Haftalık çalışma saatleri ne kadardır?",
      answer: "SSW ile tam zamanlı çalışma genellikle haftada 40 saattir. Sektöre göre fazla mesai yapma imkanı olabilir ve fazla mesailer ek ücretle ödenir. Bazı sektörlerde vardiya sistemi uygulanır. Öğrenci vizesiyle dil eğitimi sırasında ise haftada maksimum 28 saat part-time çalışma izni alınabilir."
    },
    {
      question: "SSW1'den SSW2'ye nasıl geçilir?",
      answer: "SSW2'ye geçiş için ileri seviye beceri sınavını başarıyla tamamlamanız gerekir. Ayrıca SSW2 sadece belirli sektörlerde geçerlidir (inşaat ve gemi yapımı gibi). SSW2 ile süre sınırlaması olmadan çalışabilir, ailenizi getirebilir ve uzun vadeli oturum planına adım atabilirsiniz."
    },
    {
      question: "Doğrudan SSW2 ile başvurabilir miyim?",
      answer: "Hayır, doğrudan SSW2 ile başvuru yapılamaz. Önce SSW1 ile başlamanız ve belirli bir süre çalıştıktan sonra ileri seviye sınavları geçerek SSW2'ye geçiş yapmanız gerekir. Bu süreç deneyim ve beceri gelişimi gerektirir."
    },
    {
      question: "Kalıcı oturum için kaç yıl gerekir?",
      answer: "Japonya'da kalıcı oturum için genellikle 10 yıl yasal ve kesintisiz ikamet şartı aranır. Ancak özel durumlarda (yüksek beceri sahibi profesyoneller, evlilik vb.) bu süre kısalabilir. SSW2 ile uzun vadeli çalışma, kalıcı oturum başvurusunda avantaj sağlar."
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isHeaderScrolled ? 'bg-white shadow-md py-4' : 'bg-white/95 py-6'}`}>
        <div className="container mx-auto px-4 lg:px-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <img src="https://public.readdy.ai/ai/img_res/7d8edab7-d6ae-4ad0-9e9c-3fad26b7129b.png" alt="STEB Yurt Dışı Eğitim Logo" className="h-12 w-auto" />
            </div>
            
            {/* Desktop Menu */}
            <nav className="hidden lg:flex items-center space-x-8">
              <button onClick={() => scrollToSection('japonya')} className="text-gray-700 hover:text-red-600 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Neden Japonya</button>
              <button onClick={() => scrollToSection('yolharitasi')} className="text-gray-700 hover:text-red-600 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Yol Haritası</button>
              <button onClick={() => scrollToSection('japonca')} className="text-gray-700 hover:text-red-600 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Japonca</button>
              <button onClick={() => scrollToSection('sektorler')} className="text-gray-700 hover:text-red-600 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Sektörler</button>
              <button onClick={() => scrollToSection('yasam')} className="text-gray-700 hover:text-red-600 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Yaşam</button>
              <button onClick={() => scrollToSection('uzunvade')} className="text-gray-700 hover:text-red-600 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">Uzun Vade</button>
              <button onClick={() => scrollToSection('sss')} className="text-gray-700 hover:text-red-600 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">SSS</button>
              <button onClick={() => scrollToSection('iletisim')} className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">İletişim</button>
            </nav>

            {/* Mobile Menu Button */}
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="lg:hidden text-gray-700 cursor-pointer">
              <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <nav className="lg:hidden mt-4 pb-4 flex flex-col space-y-3">
              <button onClick={() => scrollToSection('japonya')} className="text-gray-700 hover:text-red-600 transition-colors duration-300 font-medium text-left cursor-pointer">Neden Japonya</button>
              <button onClick={() => scrollToSection('yolharitasi')} className="text-gray-700 hover:text-red-600 transition-colors duration-300 font-medium text-left cursor-pointer">Yol Haritası</button>
              <button onClick={() => scrollToSection('japonca')} className="text-gray-700 hover:text-red-600 transition-colors duration-300 font-medium text-left cursor-pointer">Japonca</button>
              <button onClick={() => scrollToSection('sektorler')} className="text-gray-700 hover:text-red-600 transition-colors duration-300 font-medium text-left cursor-pointer">Sektörler</button>
              <button onClick={() => scrollToSection('yasam')} className="text-gray-700 hover:text-red-600 transition-colors duration-300 font-medium text-left cursor-pointer">Yaşam</button>
              <button onClick={() => scrollToSection('uzunvade')} className="text-gray-700 hover:text-red-600 transition-colors duration-300 font-medium text-left cursor-pointer">Uzun Vade</button>
              <button onClick={() => scrollToSection('sss')} className="text-gray-700 hover:text-red-600 transition-colors duration-300 font-medium text-left cursor-pointer">SSS</button>
              <button onClick={() => scrollToSection('iletisim')} className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer">İletişim</button>
            </nav>
          )}
        </div>
      </header>

      {/* WhatsApp Float Button */}
      <a href="https://wa.me/905522827832" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 bg-red-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg hover:bg-red-700 transition-all duration-300 hover:scale-110 cursor-pointer">
        <i className="ri-whatsapp-line text-3xl"></i>
      </a>

      {/* Hero Section */}
      <section className="relative min-h-[85vh] flex items-center justify-center pt-20">
        <div className="absolute inset-0 z-0">
          <img src="https://public.readdy.ai/ai/img_res/4b14692a09cff6ddd0cb34bf3ed00ece.jpg" alt="Tokyo Skyline ve Fuji Dağı - Japonya'da Çalışma ve Eğitim Fırsatları" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        
        <div className="container mx-auto px-4 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">Japonya'da Japonca Öğren, SSW ile Çalış</h1>
            <p className="text-lg lg:text-xl text-white/90 mb-8 leading-relaxed max-w-2xl">Dil eğitiminden sınavlara, iş sözleşmesinden vizeye ve uzun vade planına kadar Japonya hedefinizi STEB ile yapılandıralım.</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button onClick={() => scrollToSection('iletisim')} className="bg-red-600 text-white px-8 py-4 rounded-lg hover:bg-red-700 transition-all duration-300 font-semibold text-lg whitespace-nowrap cursor-pointer">Ücretsiz Ön Değerlendirme</button>
              <a href="https://wa.me/905522827832" target="_blank" rel="noopener noreferrer" className="border-2 border-white text-white px-8 py-4 rounded-lg hover:bg-white hover:text-red-600 transition-all duration-300 font-semibold text-lg flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer">
                <i className="ri-whatsapp-line text-2xl"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CEO Message Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="lg:w-1/3 flex justify-center">
              <img src="https://static.readdy.ai/image/11bca27ccb3d56cff196f9e5dc04b8f8/e910fe219940b01a92d64bf92a3d1e56.jpeg" alt="STEB CEO - Profesyonel Eğitim Danışmanlığı" className="w-48 h-48 rounded-full border-4 border-gray-200 object-cover" />
            </div>
            <div className="lg:w-2/3">
              <div className="mb-4">
                <span className="text-red-600 uppercase text-xs font-bold tracking-widest">CEO'DAN</span>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">Japonya hedefini sürdürülebilir bir kariyere dönüştürmek; doğru dil seviyesi, doğru sektör ve doğru zamanlama ile mümkündür. Biz, adayın profiline göre kişiye özel yol haritası ve evrak/süreç yönetimi sunarız.</p>
              <p className="font-bold text-gray-900">STEB Yurt Dışı Eğitim</p>
            </div>
          </div>
          
          <div className="mt-12 bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg">
            <div className="flex items-start gap-4">
              <i className="ri-alert-line text-yellow-600 text-2xl flex-shrink-0 mt-1"></i>
              <p className="text-gray-700 italic"><strong>Önemli Uyarı:</strong> Vize ve oturum kararları resmi makamlara aittir. Sonuç garantisi verilemez. STEB, başvuru süreçlerinde profesyonel destek sağlar ancak nihai kararlar Japonya göçmenlik makamları tarafından verilir.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Japan Section */}
      <section id="japonya" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Neden Japonya?</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">Japonya, güvenli yaşam ortamı, gelişmiş altyapısı ve disiplinli iş kültürü ile uluslararası kariyer fırsatları sunar</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
            <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-2 cursor-pointer">
              <div className="w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-red-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Güvenli Şehirler</h3>
              <p className="text-gray-600 leading-relaxed">Düşük suç oranı, temiz sokaklar ve güvenli yaşam ortamı ile dünyanın en güvenli ülkelerinden biri</p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-2 cursor-pointer">
              <div className="w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-train-line text-red-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Güçlü Ulaşım</h3>
              <p className="text-gray-600 leading-relaxed">Shinkansen ve metro ağı ile dakiklik odaklı, konforlu ve hızlı ulaşım sistemi</p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-2 cursor-pointer">
              <div className="w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-briefcase-line text-red-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Disiplinli İş Kültürü</h3>
              <p className="text-gray-600 leading-relaxed">Dakiklik, kalite odaklılık ve ekip çalışması ile profesyonel gelişim imkanı</p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-2 cursor-pointer">
              <div className="w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-global-line text-red-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Küresel Deneyim</h3>
              <p className="text-gray-600 leading-relaxed">Uluslararası iş deneyimi ve farklı kültürleri tanıma fırsatı ile kariyer avantajı</p>
            </div>
          </div>

          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-8">Başlıca Şehirler</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            <div className="relative rounded-2xl overflow-hidden h-80 group cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=Tokyo%20cityscape%20at%20sunset%2C%20Shibuya%20crossing%2C%20modern%20skyscrapers%2C%20neon%20lights%2C%20bustling%20urban%20life%2C%20iconic%20Tokyo%20tower%20in%20distance%2C%20vibrant%20city%20atmosphere%2C%20professional%20travel%20photography%2C%20dynamic%20composition&width=400&height=600&seq=tokyo-city-001&orientation=portrait" alt="Tokyo - Japonya'nın Başkenti ve İş Merkezi" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h4 className="text-2xl font-bold text-white mb-2">Tokyo</h4>
                <p className="text-white/90 text-sm">Başkent, en fazla iş imkanı, yüksek yaşam maliyeti, modern şehir yaşamı</p>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden h-80 group cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=Osaka%20cityscape%20at%20night%2C%20Dotonbori%20district%2C%20colorful%20neon%20signs%2C%20canal%20reflections%2C%20vibrant%20nightlife%2C%20modern%20and%20traditional%20blend%2C%20Japanese%20urban%20photography%2C%20energetic%20atmosphere&width=400&height=600&seq=osaka-city-001&orientation=portrait" alt="Osaka - Japonya'nın Ticaret Merkezi" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h4 className="text-2xl font-bold text-white mb-2">Osaka</h4>
                <p className="text-white/90 text-sm">Ticaret merkezi, canlı yaşam, Tokyo'ya göre daha uygun maliyetler</p>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden h-80 group cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=Kyoto%20traditional%20temples%20and%20gardens%2C%20ancient%20Japanese%20architecture%2C%20peaceful%20zen%20gardens%2C%20cherry%20blossoms%2C%20historic%20cultural%20heritage%2C%20serene%20atmosphere%2C%20traditional%20Japan%20photography&width=400&height=600&seq=kyoto-city-001&orientation=portrait" alt="Kyoto - Japonya'nın Kültür Başkenti" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h4 className="text-2xl font-bold text-white mb-2">Kyoto</h4>
                <p className="text-white/90 text-sm">Kültür başkenti, tarihi yapılar, turizm sektörü, huzurlu yaşam</p>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden h-80 group cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=Nagoya%20city%20skyline%2C%20modern%20industrial%20city%2C%20Nagoya%20castle%2C%20automotive%20industry%20hub%2C%20clean%20urban%20environment%2C%20Japanese%20business%20district%2C%20professional%20cityscape%20photography&width=400&height=600&seq=nagoya-city-001&orientation=portrait" alt="Nagoya - Japonya'nın Sanayi Merkezi" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h4 className="text-2xl font-bold text-white mb-2">Nagoya</h4>
                <p className="text-white/90 text-sm">Sanayi merkezi, otomotiv sektörü, dengeli yaşam maliyeti</p>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden h-80 group cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=Fukuoka%20city%20waterfront%2C%20modern%20coastal%20city%2C%20Hakata%20bay%2C%20vibrant%20food%20culture%2C%20growing%20business%20hub%2C%20Japanese%20southern%20city%2C%20warm%20atmosphere%2C%20urban%20coastal%20photography&width=400&height=600&seq=fukuoka-city-001&orientation=portrait" alt="Fukuoka - Japonya'nın Güney Kapısı" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h4 className="text-2xl font-bold text-white mb-2">Fukuoka</h4>
                <p className="text-white/90 text-sm">Güney bölgesi, gelişen iş imkanları, uygun yaşam maliyeti</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SSW Roadmap Timeline Section */}
      <section id="yolharitasi" className="py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8 max-w-5xl">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">SSW Yol Haritası</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">Japonya'da çalışma hedefinize adım adım ulaşın</p>
          </div>

          <div className="relative">
            <div className="absolute left-8 top-0 bottom-0 w-1 bg-red-600 hidden lg:block"></div>

            <div className="space-y-12">
              <div className="flex flex-col lg:flex-row items-start gap-6">
                <div className="flex-shrink-0 w-16 h-16 bg-red-600 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg z-10">1</div>
                <div className="flex-1 bg-white rounded-xl shadow-md p-8 border border-gray-100">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">N5 (A1) Online Eğitim</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">Temel Japonca seviyesi. Hiragana, Katakana ve temel kanji öğrenimi. Günlük konuşma ve basit cümleler.</p>
                  <span className="inline-block bg-red-100 text-red-600 px-4 py-2 rounded-full text-sm font-semibold">150 saat • ~6 ay</span>
                </div>
              </div>

              <div className="flex flex-col lg:flex-row items-start gap-6">
                <div className="flex-shrink-0 w-16 h-16 bg-red-600 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg z-10">2</div>
                <div className="flex-1 bg-white rounded-xl shadow-md p-8 border border-gray-100">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">Japonya'da N4 Eğitimi</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">Orta seviye Japonca. İş hayatında kullanılan temel ifadeler, günlük iletişim becerileri ve kültürel adaptasyon.</p>
                  <span className="inline-block bg-red-100 text-red-600 px-4 py-2 rounded-full text-sm font-semibold">150 saat • ~6 ay</span>
                </div>
              </div>

              <div className="flex flex-col lg:flex-row items-start gap-6">
                <div className="flex-shrink-0 w-16 h-16 bg-red-600 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg z-10">3</div>
                <div className="flex-1 bg-white rounded-xl shadow-md p-8 border border-gray-100">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">Sektörel Beceri Sınavı Hazırlığı</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">Hedef sektörünüze özel teknik Japonca ve mesleki beceri eğitimi. Sınav simülasyonları ve pratik uygulamalar.</p>
                  <span className="inline-block bg-red-100 text-red-600 px-4 py-2 rounded-full text-sm font-semibold">~6 ay</span>
                </div>
              </div>

              <div className="flex flex-col lg:flex-row items-start gap-6">
                <div className="flex-shrink-0 w-16 h-16 bg-red-600 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg z-10">4</div>
                <div className="flex-1 bg-white rounded-xl shadow-md p-8 border border-gray-100">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">SSW ile İstihdam</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">Sınav başarısı sonrası iş başvurusu, sözleşme imzalama ve SSW vizesi ile Japonya'da çalışma hayatına başlama.</p>
                  <span className="inline-block bg-green-100 text-green-600 px-4 py-2 rounded-full text-sm font-semibold">Kariyer Başlangıcı</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-16 bg-blue-50 rounded-xl p-8">
            <h4 className="text-2xl font-bold text-gray-900 mb-6 text-center">Başlangıç Dönemleri</h4>
            <div className="flex flex-wrap justify-center gap-4 mb-8">
              <span className="bg-red-600 text-white px-6 py-3 rounded-full font-semibold text-lg shadow-md">Nisan (Ana Dönem)</span>
              <span className="bg-white text-gray-700 px-6 py-3 rounded-full font-semibold border-2 border-gray-300">Temmuz</span>
              <span className="bg-white text-gray-700 px-6 py-3 rounded-full font-semibold border-2 border-gray-300">Ekim</span>
              <span className="bg-white text-gray-700 px-6 py-3 rounded-full font-semibold border-2 border-gray-300">Ocak</span>
            </div>

            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h5 className="font-bold text-gray-900 mb-4 text-lg">Örnek Zaman Çizelgesi (Nisan Dönemi)</h5>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <div className="border-l-4 border-red-600 pl-4">
                  <p className="font-semibold text-gray-900">Ekim</p>
                  <p className="text-sm text-gray-600">Evrak Hazırlığı</p>
                </div>
                <div className="border-l-4 border-red-600 pl-4">
                  <p className="font-semibold text-gray-900">Ara–Şubat</p>
                  <p className="text-sm text-gray-600">İnceleme Süreci</p>
                </div>
                <div className="border-l-4 border-red-600 pl-4">
                  <p className="font-semibold text-gray-900">Şubat Sonu</p>
                  <p className="text-sm text-gray-600">COE Onayı</p>
                </div>
                <div className="border-l-4 border-red-600 pl-4">
                  <p className="font-semibold text-gray-900">Mart–Nisan</p>
                  <p className="text-sm text-gray-600">Vize & Varış</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Japanese Language Learning Section */}
      <section id="japonca" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Japonca Öğrenimi</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">SSW için Japonca yeterlilik kritik öneme sahiptir</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            <div>
              <p className="text-lg text-gray-700 leading-relaxed mb-8">N5 başlangıç seviyesi, N4 ise iş hayatı ve sınav uyumu için kritik seviyedir. Japonca öğrenimi hem günlük yaşamda hem de iş ortamında başarılı olmanızın temelidir.</p>
              
              <div className="space-y-6">
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-book-open-line text-red-600 text-2xl"></i>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-gray-900 mb-2">N5 Seviyesi</h4>
                      <p className="text-gray-600">Temel Japonca, Hiragana, Katakana ve yaklaşık 100 kanji. Basit günlük konuşmalar ve temel cümleler.</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-graduation-cap-line text-red-600 text-2xl"></i>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-gray-900 mb-2">N4 Seviyesi</h4>
                      <p className="text-gray-600">Orta seviye Japonca, yaklaşık 300 kanji. İş hayatında kullanılan temel ifadeler ve günlük iletişim.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div className="bg-green-50 border-l-4 border-green-500 rounded-lg p-6">
                <div className="flex items-start gap-4">
                  <i className="ri-information-line text-green-600 text-2xl flex-shrink-0 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">Part-Time Çalışma İzni</h4>
                    <p className="text-gray-700 leading-relaxed">Dil eğitimi sırasında öğrenci vizesiyle haftada 28 saate kadar part-time çalışma izni alınabilir. Ayrıca izin başvurusu gerekir. Bu sayede hem deneyim kazanır hem de ek gelir elde edebilirsiniz.</p>
                  </div>
                </div>
              </div>

              <div className="bg-orange-50 border-l-4 border-orange-500 rounded-lg p-6">
                <div className="flex items-start gap-4">
                  <i className="ri-alert-line text-orange-600 text-2xl flex-shrink-0 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">Önemli Not</h4>
                    <p className="text-gray-700 leading-relaxed">Sınavların dili Japoncadır. JLPT (Japanese Language Proficiency Test) tamamen Japonca dilinde yapılır. SSW için gerekli sektörel beceri sınavları da Japonca'dır. Bu nedenle dil eğitimine ciddi önem verilmelidir.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Work Opportunities & Sectors Section */}
      <section id="sektorler" className="py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Çalışma İmkanları &amp; Sektörler</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">SSW kapsamında çeşitli sektörlerde kariyer fırsatları</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            <div className="bg-gradient-to-br from-red-600 to-red-400 rounded-2xl p-6 text-white hover:scale-105 transition-transform duration-300 cursor-pointer">
              <div className="w-14 h-14 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-hotel-line text-white text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Konaklama</h4>
              <p className="text-white/90 text-sm">Otel, ryokan ve konaklama tesisleri</p>
            </div>

            <div className="bg-gradient-to-br from-red-600 to-red-400 rounded-2xl p-6 text-white hover:scale-105 transition-transform duration-300 cursor-pointer">
              <div className="w-14 h-14 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-restaurant-line text-white text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Yiyecek Hizmetleri</h4>
              <p className="text-white/90 text-sm">Restoran, kafe ve servis sektörü</p>
            </div>

            <div className="bg-gradient-to-br from-red-600 to-red-400 rounded-2xl p-6 text-white hover:scale-105 transition-transform duration-300 cursor-pointer">
              <div className="w-14 h-14 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-cake-line text-white text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Gıda Üretimi</h4>
              <p className="text-white/90 text-sm">Gıda ve içecek üretim tesisleri</p>
            </div>

            <div className="bg-gradient-to-br from-red-600 to-red-400 rounded-2xl p-6 text-white hover:scale-105 transition-transform duration-300 cursor-pointer">
              <div className="w-14 h-14 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-building-line text-white text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Bina Temizliği</h4>
              <p className="text-white/90 text-sm">Profesyonel temizlik hizmetleri</p>
            </div>

            <div className="bg-gradient-to-br from-red-600 to-red-400 rounded-2xl p-6 text-white hover:scale-105 transition-transform duration-300 cursor-pointer">
              <div className="w-14 h-14 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-plant-line text-white text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Tarım & Balıkçılık</h4>
              <p className="text-white/90 text-sm">Tarımsal üretim ve su ürünleri</p>
            </div>

            <div className="bg-gradient-to-br from-red-600 to-red-400 rounded-2xl p-6 text-white hover:scale-105 transition-transform duration-300 cursor-pointer">
              <div className="w-14 h-14 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-car-line text-white text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Otomotiv Bakım</h4>
              <p className="text-white/90 text-sm">Araç bakım ve onarım hizmetleri</p>
            </div>

            <div className="bg-gradient-to-br from-red-600 to-red-400 rounded-2xl p-6 text-white hover:scale-105 transition-transform duration-300 cursor-pointer">
              <div className="w-14 h-14 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-hammer-line text-white text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">İnşaat</h4>
              <p className="text-white/90 text-sm">Yapı inşaat ve altyapı projeleri</p>
            </div>

            <div className="bg-gradient-to-br from-red-600 to-red-400 rounded-2xl p-6 text-white hover:scale-105 transition-transform duration-300 cursor-pointer">
              <div className="w-14 h-14 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-plane-line text-white text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Havacılık</h4>
              <p className="text-white/90 text-sm">Havalimanı ve uçak bakım hizmetleri</p>
            </div>

            <div className="bg-gradient-to-br from-red-600 to-red-400 rounded-2xl p-6 text-white hover:scale-105 transition-transform duration-300 cursor-pointer">
              <div className="w-14 h-14 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-train-line text-white text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Demiryolu & Taşımacılık</h4>
              <p className="text-white/90 text-sm">Tren ve kara taşımacılığı</p>
            </div>

            <div className="bg-gradient-to-br from-red-600 to-red-400 rounded-2xl p-6 text-white hover:scale-105 transition-transform duration-300 cursor-pointer">
              <div className="w-14 h-14 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-tree-line text-white text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Ormancılık & Ahşap</h4>
              <p className="text-white/90 text-sm">Orman ürünleri ve ahşap işleme</p>
            </div>

            <div className="bg-gradient-to-br from-red-600 to-red-400 rounded-2xl p-6 text-white hover:scale-105 transition-transform duration-300 cursor-pointer">
              <div className="w-14 h-14 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-ship-line text-white text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Gemi & Denizcilik</h4>
              <p className="text-white/90 text-sm">Gemi yapımı ve deniz taşımacılığı</p>
            </div>

            <div className="bg-gradient-to-br from-red-600 to-red-400 rounded-2xl p-6 text-white hover:scale-105 transition-transform duration-300 cursor-pointer">
              <div className="w-14 h-14 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-heart-pulse-line text-white text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Bakım Hizmetleri</h4>
              <p className="text-white/90 text-sm">Yaşlı ve hasta bakım hizmetleri</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            <div className="bg-gray-50 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-red-600 text-2xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Çalışma Düzeni</h4>
                  <p className="text-gray-600 text-sm">Genelde 40 saat/hafta. Fazla mesai olabilir (ek ödemeli). Bazı sektörlerde vardiya sistemi.</p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-money-dollar-circle-line text-red-600 text-2xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Maaş Bilgisi</h4>
                  <p className="text-gray-600 text-sm">SSW1'de brüt aylık yaklaşık 170.000–250.000 JPY aralığı. Şehir ve pozisyona göre değişir.</p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-calendar-check-line text-red-600 text-2xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Fazla Mesai</h4>
                  <p className="text-gray-600 text-sm">Sektöre göre fazla mesai imkanı. Ek ücret ile ödenir. Yasal limitler dahilinde.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Life in Japan Section */}
      <section id="yasam" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Japonya'da Yaşam</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">Günlük yaşam, ulaşım ve kültürel adaptasyon</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            <div className="relative rounded-2xl overflow-hidden h-96 group">
              <img src="https://readdy.ai/api/search-image?query=Japanese%20Shinkansen%20bullet%20train%20at%20modern%20station%20platform%2C%20sleek%20white%20train%20design%2C%20clean%20station%20interior%2C%20punctual%20transportation%20system%2C%20professional%20railway%20photography%2C%20high%20speed%20rail%2C%20efficient%20public%20transport&width=800&height=600&seq=shinkansen-001&orientation=landscape" alt="Japonya Ulaşım Sistemi - Shinkansen ve Metro" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-train-line text-white text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">Ulaşım</h3>
                <ul className="text-white/90 space-y-2">
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-red-400 mt-1"></i>
                    <span>Metro ve tren ağı ile her yere kolay ulaşım</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-red-400 mt-1"></i>
                    <span>Dakiklik odaklı, güvenilir sistem</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-red-400 mt-1"></i>
                    <span>Shinkansen ile şehirler arası hızlı seyahat</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden h-96 group">
              <img src="https://readdy.ai/api/search-image?query=Japanese%20share%20house%20interior%2C%20modern%20minimalist%20room%2C%20clean%20organized%20living%20space%2C%20cozy%20bedroom%20with%20futon%2C%20simple%20furniture%2C%20natural%20light%2C%20comfortable%20student%20accommodation%2C%20contemporary%20Japanese%20housing&width=800&height=600&seq=sharehouse-001&orientation=landscape" alt="Japonya Konaklama - Share House ve Lojman Seçenekleri" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-home-line text-white text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">Konaklama</h3>
                <ul className="text-white/90 space-y-2">
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-red-400 mt-1"></i>
                    <span>Share house (paylaşımlı ev) seçenekleri</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-red-400 mt-1"></i>
                    <span>İşveren tarafından sağlanan lojman</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-red-400 mt-1"></i>
                    <span>Öğrenci yurtları (dil okulu döneminde)</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden h-96 group">
              <img src="https://readdy.ai/api/search-image?query=Japanese%20workplace%20culture%2C%20professional%20office%20environment%2C%20team%20meeting%2C%20respectful%20business%20interaction%2C%20organized%20workspace%2C%20Japanese%20business%20etiquette%2C%20collaborative%20work%20atmosphere%2C%20modern%20office%20interior&width=800&height=600&seq=workplace-001&orientation=landscape" alt="Japonya İş Kültürü - Disiplin ve Ekip Çalışması" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-team-line text-white text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">Kültür</h3>
                <ul className="text-white/90 space-y-2">
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-red-400 mt-1"></i>
                    <span>Kurallara uyum ve saygı kültürü</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-red-400 mt-1"></i>
                    <span>Ekip çalışması ve iletişim önceliği</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-red-400 mt-1"></i>
                    <span>Dakiklik ve sorumluluk bilinci</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-yellow-50 rounded-2xl p-8 h-96 flex flex-col justify-center">
              <div className="w-12 h-12 bg-yellow-200 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-checkbox-circle-line text-yellow-700 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">İlk Ay Kontrol Listesi</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-blank-circle-line text-red-600 mt-1"></i>
                  <span className="text-gray-700">Bütçe planlaması ve ilk ay masrafları</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-blank-circle-line text-red-600 mt-1"></i>
                  <span className="text-gray-700">Telefon hattı ve internet bağlantısı</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-blank-circle-line text-red-600 mt-1"></i>
                  <span className="text-gray-700">Banka hesabı açma işlemleri</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-blank-circle-line text-red-600 mt-1"></i>
                  <span className="text-gray-700">İkamet kartı (Zairyu Card) başvurusu</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-blank-circle-line text-red-600 mt-1"></i>
                  <span className="text-gray-700">Sağlık sigortası kayıt işlemleri</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Long-term Plan Section */}
      <section id="uzunvade" className="py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Uzun Vade: SSW1 → SSW2 → Oturum</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">Japonya'da kalıcı kariyer ve oturum planınız</p>
          </div>

          <div className="flex flex-col lg:flex-row items-center justify-center gap-8 mb-12">
            <div className="flex-1 bg-white border-4 border-red-600 rounded-2xl p-8 max-w-sm">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-file-list-line text-red-600 text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">SSW1</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-red-600 mt-1 flex-shrink-0"></i>
                  <span>Belirli sektörlerde çalışma hakkı</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-red-600 mt-1 flex-shrink-0"></i>
                  <span>Toplam 5 yıla kadar süre</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-red-600 mt-1 flex-shrink-0"></i>
                  <span>Tecrübe ve beceri kazanımı</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-red-600 mt-1 flex-shrink-0"></i>
                  <span>Japonca ve iş deneyimi</span>
                </li>
              </ul>
            </div>

            <div className="flex items-center justify-center">
              <i className="ri-arrow-right-line text-red-600 text-5xl hidden lg:block"></i>
              <i className="ri-arrow-down-line text-red-600 text-5xl lg:hidden"></i>
            </div>

            <div className="flex-1 bg-red-50 border-4 border-red-600 rounded-2xl p-8 max-w-sm">
              <div className="w-16 h-16 bg-red-200 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-star-line text-red-600 text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">SSW2</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-red-600 mt-1 flex-shrink-0"></i>
                  <span>Süre sınırlaması olmadan yenileme</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-red-600 mt-1 flex-shrink-0"></i>
                  <span>Aile getirme hakkı</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-red-600 mt-1 flex-shrink-0"></i>
                  <span>İleri seviye beceri sınavı gerekli</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-red-600 mt-1 flex-shrink-0"></i>
                  <span>Uzun vadeli oturum planı</span>
                </li>
              </ul>
            </div>

            <div className="flex items-center justify-center">
              <i className="ri-arrow-right-line text-red-600 text-5xl hidden lg:block"></i>
              <i className="ri-arrow-down-line text-red-600 text-5xl lg:hidden"></i>
            </div>

            <div className="flex-1 bg-white border-4 border-red-600 rounded-2xl p-8 max-w-sm">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-home-heart-line text-red-600 text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Kalıcı Oturum</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-red-600 mt-1 flex-shrink-0"></i>
                  <span>Genelde 10 yıl yasal ikamet şartı</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-red-600 mt-1 flex-shrink-0"></i>
                  <span>Kesintisiz ikamet gerekli</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-red-600 mt-1 flex-shrink-0"></i>
                  <span>Özel durumlarda süre kısalabilir</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-red-600 mt-1 flex-shrink-0"></i>
                  <span>Tam yerleşim hakkı</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-blue-50 border-l-4 border-blue-500 rounded-lg p-6 max-w-4xl mx-auto">
            <div className="flex items-start gap-4">
              <i className="ri-information-line text-blue-600 text-2xl flex-shrink-0 mt-1"></i>
              <p className="text-gray-700 leading-relaxed"><strong>Kalıcı Oturum Şartları:</strong> Japonya'da kalıcı oturum için genellikle 10 yıl yasal ve kesintisiz ikamet şartı aranır. Ancak yüksek beceri sahibi profesyoneller, evlilik veya diğer özel durumlarda bu süre kısalabilir. SSW2 ile uzun vadeli çalışma, kalıcı oturum başvurusunda önemli avantaj sağlar.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="sss" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8 max-w-4xl">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Sık Sorulan Sorular</h2>
            <p className="text-lg text-gray-600">Japonya Work and Study programı hakkında merak edilenler</p>
          </div>

          <div className="space-y-4">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-white rounded-lg shadow-sm overflow-hidden">
                <button onClick={() => toggleAccordion(index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors duration-300 cursor-pointer">
                  <span className="font-bold text-lg text-gray-900 pr-4">{faq.question}</span>
                  <i className={`${activeAccordion === index ? 'ri-subtract-line' : 'ri-add-line'} text-red-600 text-2xl flex-shrink-0 transition-transform duration-300`}></i>
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${activeAccordion === index ? 'max-h-96' : 'max-h-0'}`}>
                  <div className="px-6 pb-5 text-gray-700 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact & Form Section */}
      <section id="iletisim" className="py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Kişiye Özel Yol Haritası ve Maliyet Analizi</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">Program maliyetleri; Japonca seviyeniz, hedef sektör, şehir ve zamanlamaya göre değişir. Tüm detaylar ve net bütçe için bize ulaşın.</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
            <div className="lg:col-span-2">
              <div className="space-y-8">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">İletişim Bilgileri</h3>
                  <div className="space-y-4">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-map-pin-line text-red-600 text-xl"></i>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-900">Adres</p>
                        <p className="text-gray-600">Bestekar Cd 78/11 Çankaya 06680 Ankara</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-phone-line text-red-600 text-xl"></i>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-900">Telefon</p>
                        <p className="text-gray-600">+90 312 417 88 11</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-whatsapp-line text-red-600 text-xl"></i>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-900">WhatsApp</p>
                        <p className="text-gray-600">+90 552 282 78 32</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-mail-line text-red-600 text-xl"></i>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-900">E-posta</p>
                        <p className="text-gray-600">info@steb.com.tr</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-global-line text-red-600 text-xl"></i>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-900">Web</p>
                        <p className="text-gray-600">www.steb.com.tr</p>
                      </div>
                    </div>

                    <div className="flex gap-3 mt-6">
                      <a href="https://wa.me/905522827832" target="_blank" rel="noopener noreferrer" className="flex-1 flex items-center justify-center gap-2 bg-green-600 text-white py-3 px-4 rounded-lg hover:bg-green-700 transition-colors duration-300 font-semibold cursor-pointer whitespace-nowrap">
                        <i className="ri-whatsapp-line text-xl"></i>
                        WhatsApp
                      </a>
                      <a href="tel:+903124178811" className="flex-1 flex items-center justify-center gap-2 bg-red-600 text-white py-3 px-4 rounded-lg hover:bg-red-700 transition-colors duration-300 font-semibold cursor-pointer whitespace-nowrap">
                        <i className="ri-phone-line text-xl"></i>
                        Ara
                      </a>
                    </div>

                    <div className="mt-8">
                      <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
                        <i className="ri-map-pin-2-fill text-red-600"></i>
                        Ofis Konumu
                      </h4>
                      <div className="w-full h-56 rounded-xl overflow-hidden border border-gray-200 shadow-sm relative group cursor-pointer">
                        <a
                          href="https://www.google.com/maps/dir/?api=1&destination=Bestekar+Cd+78%2F11+%C3%87ankaya+Ankara"
                          target="_blank"
                          rel="nofollow noopener noreferrer"
                          className="absolute inset-0 z-10 flex items-center justify-center bg-black/0 group-hover:bg-black/30 transition-all duration-300"
                          title="Google Maps'te Yol Tarifi Al"
                        >
                          <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-red-600 text-white px-5 py-2.5 rounded-lg font-semibold text-sm flex items-center gap-2 shadow-lg whitespace-nowrap">
                            <i className="ri-direction-fill w-5 h-5 flex items-center justify-center"></i>
                            Yol Tarifi Al
                          </span>
                        </a>
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060.5!2d32.8580!3d39.9180!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d34f1b0a5a8f0d%3A0x0!2sBestekar+Cd+78%2F11+%C3%87ankaya+Ankara!5e0!3m2!1str!2str!4v1700000000000!5m2!1str!2str"
                          width="100%"
                          height="100%"
                          style={{ border: 0, pointerEvents: 'none' }}
                          allowFullScreen
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                          title="STEB Yurt Dışı Eğitim Ofis Konumu - Bestekar Cd 78/11 Çankaya Ankara"
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:col-span-3">
              <div className="bg-gray-50 rounded-2xl p-8 lg:p-10">
                <form id="contact-form" data-readdy-form action="https://readdy.ai/api/form/d6eqjnrv53dtlm7j9bgg" method="POST" onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  const data = new URLSearchParams(formData as any);
                  
                  fetch(form.action, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: data.toString()
                  })
                  .then(response => {
                    if (response.ok) {
                      alert('Başvurunuz başarıyla gönderildi! En kısa sürede sizinle iletişime geçeceğiz.');
                      form.reset();
                    } else {
                      alert('Bir hata oluştu. Lütfen tekrar deneyin.');
                    }
                  })
                  .catch(() => {
                    alert('Bir hata oluştu. Lütfen tekrar deneyin.');
                  });
                }}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="name" className="block text-sm font-bold text-gray-700 mb-2">Ad Soyad *</label>
                      <input type="text" id="name" name="name" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent" />
                    </div>

                    <div>
                      <label htmlFor="phone" className="block text-sm font-bold text-gray-700 mb-2">Telefon *</label>
                      <input type="tel" id="phone" name="phone" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent" />
                    </div>

                    <div>
                      <label htmlFor="email" className="block text-sm font-bold text-gray-700 mb-2">E-posta *</label>
                      <input type="email" id="email" name="email" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent" />
                    </div>

                    <div>
                      <label htmlFor="age" className="block text-sm font-bold text-gray-700 mb-2">Yaş *</label>
                      <input type="number" id="age" name="age" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent" />
                    </div>

                    <div>
                      <label htmlFor="education" className="block text-sm font-bold text-gray-700 mb-2">Eğitim Durumu *</label>
                      <select id="education" name="education" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent cursor-pointer">
                        <option value="">Seçiniz</option>
                        <option value="Lise">Lise</option>
                        <option value="Ön Lisans">Ön Lisans</option>
                        <option value="Lisans">Lisans</option>
                        <option value="Yüksek Lisans">Yüksek Lisans</option>
                      </select>
                    </div>

                    <div>
                      <label htmlFor="experience" className="block text-sm font-bold text-gray-700 mb-2">İş Deneyimi *</label>
                      <select id="experience" name="experience" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent cursor-pointer">
                        <option value="">Seçiniz</option>
                        <option value="Yok">Yok</option>
                        <option value="1-3 yıl">1-3 yıl</option>
                        <option value="3-5 yıl">3-5 yıl</option>
                        <option value="5+ yıl">5+ yıl</option>
                      </select>
                    </div>

                    <div>
                      <label htmlFor="japanese_level" className="block text-sm font-bold text-gray-700 mb-2">Japonca Seviyesi *</label>
                      <select id="japanese_level" name="japanese_level" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent cursor-pointer">
                        <option value="">Seçiniz</option>
                        <option value="Hiç bilmiyorum">Hiç bilmiyorum</option>
                        <option value="N5">N5</option>
                        <option value="N4">N4</option>
                        <option value="N3">N3</option>
                        <option value="N2">N2</option>
                        <option value="N1">N1</option>
                      </select>
                    </div>

                    <div>
                      <label htmlFor="sector" className="block text-sm font-bold text-gray-700 mb-2">Hedef Sektör *</label>
                      <select id="sector" name="sector" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent cursor-pointer">
                        <option value="">Seçiniz</option>
                        <option value="Konaklama">Konaklama</option>
                        <option value="Yiyecek Hizmetleri">Yiyecek Hizmetleri</option>
                        <option value="Gıda Üretimi">Gıda Üretimi</option>
                        <option value="Bina Temizliği">Bina Temizliği</option>
                        <option value="Tarım & Balıkçılık">Tarım & Balıkçılık</option>
                        <option value="Otomotiv Bakım">Otomotiv Bakım</option>
                        <option value="İnşaat">İnşaat</option>
                        <option value="Havacılık">Havacılık</option>
                        <option value="Demiryolu & Taşımacılık">Demiryolu & Taşımacılık</option>
                        <option value="Bakım Hizmetleri">Bakım Hizmetleri</option>
                        <option value="Diğer">Diğer</option>
                      </select>
                    </div>

                    <div className="bg-gray-50 rounded-xl p-6">
                      <div className="flex items-start gap-4">
                        <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                          <i className="ri-calendar-check-line text-red-600 text-2xl"></i>
                        </div>
                        <div>
                          <h4 className="font-bold text-gray-900 mb-2">Başlangıç Dönemi *</h4>
                          <select id="start_period" name="start_period" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent cursor-pointer">
                            <option value="">Seçiniz</option>
                            <option value="Nisan">Nisan</option>
                            <option value="Temmuz">Temmuz</option>
                            <option value="Ekim">Ekim</option>
                            <option value="Ocak">Ocak</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="md:col-span-2">
                      <label htmlFor="message" className="block text-sm font-bold text-gray-700 mb-2">Notunuz</label>
                      <textarea id="message" name="message" rows={4} maxLength={500} className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent resize-none" placeholder="Eklemek istediğiniz bilgiler (maksimum 500 karakter)"></textarea>
                    </div>

                    <div className="md:col-span-2">
                      <label className="flex items-start gap-3 cursor-pointer">
                        <input type="checkbox" name="kvkk" required className="mt-1 w-5 h-5 text-red-600 border-gray-300 rounded focus:ring-red-600 cursor-pointer" />
                        <span className="text-sm text-gray-700">KVKK kapsamında kişisel verilerimin işlenmesini kabul ediyorum. *</span>
                      </label>
                    </div>
                  </div>

                  <button type="submit" className="w-full mt-8 bg-red-600 text-white py-4 rounded-lg hover:bg-red-700 transition-colors duration-300 font-bold text-lg whitespace-nowrap cursor-pointer">Başvuru Gönder</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div>
              <img src="https://public.readdy.ai/ai/img_res/7d8edab7-d6ae-4ad0-9e9c-3fad26b7129b.png" alt="STEB Yurt Dışı Eğitim" className="h-12 mb-4" />
              <p className="text-gray-300 text-sm leading-relaxed">Japonya'da eğitim ve çalışma hayatınız için güvenilir danışmanlık hizmeti.</p>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">İletişim</h4>
              <div className="space-y-2 text-sm text-gray-300">
                <p className="flex items-start gap-2">
                  <i className="ri-map-pin-line mt-1"></i>
                  <span>Bestekar Cd 78/11 Çankaya 06680 Ankara</span>
                </p>
                <p className="flex items-center gap-2">
                  <i className="ri-phone-line"></i>
                  <span>+90 312 417 88 11</span>
                </p>
                <p className="flex items-center gap-2">
                  <i className="ri-whatsapp-line"></i>
                  <span>+90 552 282 78 32</span>
                </p>
                <p className="flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  <span>info@steb.com.tr</span>
                </p>
              </div>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Hızlı Linkler</h4>
              <div className="space-y-2 text-sm">
                <button onClick={() => scrollToSection('japonya')} className="block text-gray-300 hover:text-white transition-colors cursor-pointer">Neden Japonya</button>
                <button onClick={() => scrollToSection('yolharitasi')} className="block text-gray-300 hover:text-white transition-colors cursor-pointer">Yol Haritası</button>
                <button onClick={() => scrollToSection('sektorler')} className="block text-gray-300 hover:text-white transition-colors cursor-pointer">Sektörler</button>
                <button onClick={() => scrollToSection('sss')} className="block text-gray-300 hover:text-white transition-colors cursor-pointer">SSS</button>
                <button onClick={() => scrollToSection('iletisim')} className="block text-gray-300 hover:text-white transition-colors cursor-pointer">İletişim</button>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-8 text-center">
            <p className="text-gray-400 text-sm">&copy; 2025 STEB Yurt Dışı Eğitim. Tüm hakları saklıdır. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Powered by Readdy</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}